/**
 * ! Typically with Remix we don't need to handle loading states because almost everything is SSR and it trigger the browser bar "loading state" however for page loads that we expect to be very long like loading a document, when a link is clicked, we can use this overlay to show a more prominent loading state
 * @returns
 */
export function LoadingOverlay({ open }: { open: boolean }) {
  if (!open) return null;

  return (
    <div id="loading-overlay" className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-60">
      <svg
        className="mr-4 h-8 w-8 animate-spin text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>

      <span className="text-3xl font-bold text-white">Loading...</span>
    </div>
  );
}
